import {
  SimpleFacilityModel,
  CreateFacilityModel,
  UpdateFacilityTemplateModel,
  FacilityFeatureFlagsEnum,
  FacilityModel,
} from "../utils/types/facility";
import {http} from "./api/restApiClient";
import {ApiResponse} from "apisauce";
import {Page} from "./api/pagination";

import {OrganizationsService} from "./OrganizationsService";
import {PccIntegrationStatus} from "./PccService";

export const facilityHasPccTurnedOn = (facility: Facility) =>
  facility?.pccIntegrationStatus === PccIntegrationStatus.PccTurnedOn;

export const facilityHasPccUploadActive = (facility: Facility) =>
  Boolean(facility?.pccUploadActive);

export const getFacilityFeatureFlags = (facility: Facility) => ({
  facilityHasPccTurnedOn: facilityHasPccTurnedOn(facility),
  facilityHasPccUploadActive: facilityHasPccUploadActive(facility),
  facilityHasOrgAdminOnlyDeleteAdmissions:
    !!facility.featureFlags?.[
      FacilityFeatureFlagsEnum.ORG_ADMIN_ONLY_DELETE_ADMISSIONS
    ],
});

export type Facility = SimpleFacilityModel;

export const FacilityService = {
  /**
   * Get all facilities for the authenticated user.
   * Returns facilities filtered by user's role scope (RESIDE, ORGANIZATION, or FACILITY).
   */
  getAll: (): Promise<ApiResponse<Page<FacilityModel>>> =>
    http.get<Page<FacilityModel>>("/facilities"),

  /**
   * Get facilities for a specific organization.
   */
  findByOrganization: (organizationId: string) =>
    OrganizationsService.getOrganizationFacilities(organizationId),

  create: (facility: CreateFacilityModel) => http.post("/facilities", facility),

  patch: (facilityId: string, updateModel: UpdateFacilityTemplateModel) =>
    http.patch(`/facilities/${facilityId}`, updateModel),
};
